import { isProjectsModulePreviewEnabled } from 'models/copilot/copilotPreviewFeatureToggles';
import { ModuleProjects, Settings } from 'models/setting';

/**
 * The two tenant-level halves of the Projects module gate: the tenant switched the module on, and
 * the module is released to this tenant. Unlike the older modules, ModuleProjects defaults to
 * false and an absent setting means off - it is opt-in, so this checks `=== true` rather than
 * `!== false`. The third half is per audience and is not part of this helper:
 * FeatureTypes.Projects.
 */
export const isProjectsModuleEnabledForTenant = (settings: Settings | undefined): boolean => {
  return (settings?.get(ModuleProjects) as boolean) === true && isProjectsModulePreviewEnabled(settings);
};
